import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const tariffCustomTitleMap: Record<string, string> = getFeature('tariff-custom-title-map') || {};
